import { createAsyncThunk } from '@reduxjs/toolkit';

import {
  AdminApiPaths,
  TApiResponse,
  APIDataProvider,
  TApiPaginationResponse,
} from '../../../api';
import { IStudentSubscriptionRate } from '.';

export type TAdminCreateStudentSubscriptionRate = {
  package: string;
  amounts: Array<{
    studentSubscriptionRateVersion: string;
    amount: number;
    currency: string;
  }>;
  country?: string;
  curriculum?: string;
  grade?: string;
};

export type TAdminGetStudentSubscriptionRates = {
  limit: number;
  offset: number;
  sortKey?: string;
  sortValue?: number;
  searchText?: string;
  packageId?: string;
  country?: string;
  curriculum?: string;
  grade?: string;
};

export type TAdminUpdateStudentSubscriptionRate = {
  id: string;
  package: string;
  amounts: Array<{
    studentSubscriptionRateVersion: string;
    amount: number;
    currency: string;
  }>;
  country?: string;
  curriculum?: string;
  grade?: string;
};

export type TGetUserSubscriptionRates = {
  userId: string;
  curriculum?: string;
  grade?: string;
};

const apiDataProvider = new APIDataProvider();

const adminGetStudentSubscriptionRatesModule = async ({
  limit,
  offset,
  sortKey,
  sortValue,
  searchText,
  packageId,
  country,
  curriculum,
  grade,
}: TAdminGetStudentSubscriptionRates) => {
  let path = `${AdminApiPaths.adminStudentSubscriptionRates}?limit=${limit}&offset=${offset}`;

  if (sortKey) {
    path += `&sortKey=${sortKey}`;
  }

  if (sortKey) {
    path += `&sortValue=${sortValue}`;
  }

  if (searchText) {
    path += `&searchText=${searchText}`;
  }

  if (packageId) {
    path += `&packageId=${packageId}`;
  }

  if (country) {
    path += `&country=${country}`;
  }

  if (curriculum) {
    path += `&curriculum=${curriculum}`;
  }

  if (grade) {
    path += `&grade=${grade}`;
  }

  const response = await apiDataProvider.get<
    TApiResponse<TApiPaginationResponse<IStudentSubscriptionRate>>
  >(path);

  return response.data;
};

export const adminCreateStudentSubscriptionRate = createAsyncThunk(
  '/admin/student-subscription-rates/create',
  async (data: TAdminCreateStudentSubscriptionRate) => {
    const path = `${AdminApiPaths.adminStudentSubscriptionRates}`;

    const response = await apiDataProvider.post<
      TApiResponse<IStudentSubscriptionRate>
    >(path, data);

    return response.data;
  }
);

export const adminUpdateStudentSubscriptionRate = createAsyncThunk(
  '/admin/student-subscription-rates/update',
  async (data: TAdminUpdateStudentSubscriptionRate) => {
    const path = `${AdminApiPaths.adminStudentSubscriptionRates}/${data.id}`;

    const response = await apiDataProvider.put<
      TApiResponse<IStudentSubscriptionRate>
    >(path, data);

    return response.data;
  }
);

export const adminDeleteStudentSubscriptionRate = createAsyncThunk(
  '/admin/student-subscription-rates/delete',
  async (id: string) => {
    const path = `${AdminApiPaths.adminStudentSubscriptionRates}/${id}`;

    const response = await apiDataProvider.delete<
      TApiResponse<IStudentSubscriptionRate>
    >(path);

    return response.data;
  }
);

export const getUserSubscriptionRatesAsAdmin = createAsyncThunk(
  '/admin/subscription-plan-rates/user/list',
  async ({ userId, curriculum, grade }: TGetUserSubscriptionRates) => {
    let path = `${AdminApiPaths.adminStudentSubscriptionRates}/user/${userId}?userId=${userId}`;

    if (curriculum) {
      path += `&curriculum=${curriculum}`;
    }

    if (grade) {
      path += `&grade=${grade}`;
    }

    const response = await apiDataProvider.get<
      TApiResponse<IStudentSubscriptionRate[]>
    >(path);

    return response.data;
  }
);

export const adminGetStudentSubscriptionRates = createAsyncThunk(
  '/admin/student-subscription-rates/list',
  adminGetStudentSubscriptionRatesModule
);
